import type { ReceiptTemplate } from '../schema';

export const quickbooksTemplate: ReceiptTemplate = {
  id: 'quickbooks',
  name: 'QuickBooks Receipt',
  brand: 'QUICKBOOKS',
  description: 'QuickBooks subscription receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'qb-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: 'QUICKBOOKS',
        businessNameFontSize: 18,
        addressLines: ['BY INTUIT', 'PAYMENT RECEIPT'],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'qb-trans',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'invoice', label: 'Invoice:', value: 'QB-847291034' },
          { id: 'company', label: 'Company:', value: 'Acme Corp' },
        ],
        column2: [
          { id: 'date', label: 'Date:', value: '01/04/2026' },
          { id: 'type', label: 'Billing:', value: 'Monthly' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'qb-plan',
      type: 'custom-message',
      enabled: true,
      config: { alignment: 'left', message: 'PLAN: QuickBooks Online Plus\nUSERS: 5\nNEXT BILLING: 02/04/2026', fontSize: 12, showDivider: true, dividerStyle: 'dashed', isBold: false },
    },
    {
      id: 'qb-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'sub', label: 'SUBSCRIPTION', value: '80.00', isBold: false, isLarge: false },
          { id: 'payroll', label: 'PAYROLL ADD-ON', value: '45.00', isBold: false, isLarge: false },
          { id: 'tax', label: 'TAX', value: '10.31', isBold: false, isLarge: false },
          { id: 'total', label: 'TOTAL', value: '135.31', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'qb-payment',
      type: 'payment',
      enabled: true,
      config: { alignment: 'left', method: 'VISA ****4144', fields: [], showDivider: true, dividerStyle: 'dashed' },
    },
    {
      id: 'qb-footer',
      type: 'custom-message',
      enabled: true,
      config: { alignment: 'center', message: 'PAYMENT SUCCESSFUL', fontSize: 12, showDivider: false, dividerStyle: 'solid', isBold: true },
    },
  ],
  updatedAt: new Date().toISOString(),
};

